[
  {
    "name": "admin_pages_homepage",
    "path": "/",
    "ref": null,
    "icon": "fa-solid fa-home",
    "subMenu": []
  },
  {
    "name": "admin_pages_analytics",
    "ref": "admin_pages_analytics_reports",
    "icon": "fa-solid fa-chart-mixed",
    "subMenu": [
      {
        "name": "admin_components_analytics_dashboard",
        "path": "/dashboard",
        "ref": "admin_pages_analytics_dashboard"
      },
      {
        "name": "admin_components_analytics_pointreport",
        "path": "/spendable-point-report",
        "ref": "admin_pages_analytics_spendablepointreport"
      },
      {
        "name": "admin_components_analytics_distributablepointreport",
        "path": "/distributable-point-report",
        "ref": "admin_pages_analytics_distributablepointreport"
      },
      {
        "name": "admin_components_analytics_pointresetreport",
        "path": "/point-reset-report",
        "ref": "admin_pages_analytics_pointresetreport"
      },
      {
        "name": "admin_components_analytics_rewardreport",
        "path": "/reward-report",
        "ref": "admin_pages_analytics_rewardreport"
      },
      {
        "name": "admin_report_index_givings",
        "path": "/post-report",
        "ref": "admin_pages_analytics_postreport"
      },
      {
        "name": "admin_components_analytics_givenrewardreport",
        "path": "/given-reward-report",
        "ref": "admin_pages_analytics_givenrewardreport"
      },
      {
        "name": "admin_components_analytics_loginreport",
        "path": "/portal-login-report",
        "ref": "admin_pages_analytics_portalloginreport"
      },
      {
        "name": "admin_components_analytics_postbasedreport",
        "path": "/post-based-report",
        "ref": "admin_pages_analytics_postbasedreport"
      },
      {
        "name": "admin_components_analytics_postbaseddetailedreport",
        "path": "/post-based-detailed-report",
        "ref": "admin_pages_analytics_postbaseddetailedreport"
      },
      {
        "name": "admin_components_analytics_messagereport",
        "path": "/message-report",
        "ref": "admin_pages_analytics_messagereport"
      },
      {
        "name": "admin_pages_analytics_communityreport",
        "path": "/community-report",
        "ref": "admin_pages_analytics_getcommunityreport"
      },
      {
        "name": "admin_pages_analytics_tierreport",
        "path": "/tier-report",
        "ref": "admin_pages_analytics_tierreport"
      },
      {
        "name": "admin_pages_analytics_internaltiesreport",
        "path": "/internal-ties-report",
        "ref": "admin_pages_analytics_internaltiesreport"
      },
      {
        "name": "admin_pages_analytics_abusereport",
        "path": "/abuse-report",
        "ref": "admin_pages_analytics_abusereport"
      },
      {
        "name": "admin_pages_analytics_accessreport",
        "path": "/access-report",
        "ref": "admin_pages_analytics_accessreport"
      },
      {
        "name": "admin_pages_analytics_engagementreport",
        "path": "/engagement-report",
        "ref": "admin_pages_analytics_engagementreport"
      },
      {
        "name": "admin_pages_analytics_temporalchangesreport",
        "path": "/temporal-changes-report",
        "ref": "admin_pages_analytics_temporalchangesreport"
      },
      {
        "name": "admin_pages_analytics_commentreport",
        "path": "/comment-report",
        "ref": "admin_pages_analytics_commentreport"
      }
    ]
  },
  {
    "name": "admin_components_sidebar_companysettings",
    "ref": "admin_pages_company_settings",
    "icon": "fa-solid fa-gear",
    "subMenu": [
      {
        "name": "admin_company_settings_displaysettings",
        "path": "/display-settings",
        "ref": "admin_components_company_display_settings"
      },
      {
        "name": "admin_company_settings_departmentsettings",
        "path": "/department-settings",
        "ref": "admin_components_company_department_wrapper"
      },
      {
        "name": "admin_company_settings_positionsettings",
        "path": "/position-settings",
        "ref": "admin_components_company_position_wrapper"
      },
      {
        "name": "admin_company_settings_employeetypesettings",
        "path": "/employee-type-settings",
        "ref": "admin_components_company_settings_employeetype_wrapper"
      },
      {
        "name": "admin_company_settings_locationsettings",
        "path": "/location-settings",
        "ref": "admin_components_company_settings_location_wrapper"
      },
      {
        "name": "admin_pages_companysettings_levelsettings",
        "path": "/level-settings",
        "ref": "admin_pages_company_settings_level_wrapper"
      },
      {
        "name": "admin_company_settings_pointsettings",
        "path": "/point-settings",
        "ref": "admin_pages_point_settings"
      },
      {
        "name": "admin_company_settings_menusettings",
        "path": "/menu-settings",
        "ref": "admin_components_company_menu_settings_wrapper"
      },
      {
        "name": "admin_company_settings_holidaysettings",
        "path": "/holiday-settings",
        "ref": "admin_company_holiday_settings"
      },
      {
        "name": "admin_company_settings_informationsettings",
        "path": "/information-settings",
        "ref": "admin_company_settings_information_settings"
      },
      {
        "name": "admin_company_settings_manualpoint",
        "path": "/manual-point-settings",
        "ref": "admin_components_company_manualpoint_wrapper"
      },
      {
        "name": "admin_company_settings_integrations",
        "path": "/integrations",
        "ref": "admin_components_company_settings_integrations_wrapper"
      }
    ]
  },
  {
    "name": "admin_components_sidebar_employeemanagement",
    "ref": "admin_pages_employee_management",
    "icon": "fa-solid fa-user-group",
    "subMenu": [
      {
        "name": "admin_employee_management_employees",
        "path": "/employee-management",
        "ref": "admin_pages_employee_management_employees"
      },
      {
        "name": "admin_administrator_management_permission",
        "path": "/permissions",
        "ref": "admin_pages_employee_management_permissions"
      },
      {
        "name": "admin_administrator_management_filters",
        "path": "/filters",
        "ref": "admin_pages_employee_management_filters"
      },
      {
        "name": "admin_employee_management_profileborders",
        "path": "/employee-borders",
        "ref": "admin_pages_emplooyee_management_borders"
      }
    ]
  },
  {
    "name": "admin_components_sidebar_appreciationsettings",
    "ref": "admin_pages_sharing_settings",
    "icon": "fa-solid fa-comment",
    "subMenu": [
      {
        "name": "admin_appreciation_settings_companyvalue",
        "path": "/company-value-settings",
        "ref": "admin_pages_sharing_settings_company_value"
      },
      {
        "name": "admin_appreciation_settings_companyvaluetype",
        "path": "/company-value-types",
        "ref": "admin_pages_sharing_settings_company_value_types"
      },
      {
        "name": "admin_appreciation_settings_reports",
        "path": "/sharing-complaints",
        "ref": "admin_pages_sharing_settings_sharing_complaints"
      },
      {
        "name": "admin_appreciation_settings_celebrationsbordersettings",
        "path": "/celebration-settings",
        "ref": "admin_pages_sharing_settings_celebrations_border_settings"
      },
      {
        "name": "admin_appreciation_settings_postcards",
        "path": "/post-cards",
        "ref": "admin_pages_sharing_settings_post_cards"
      },
      {
        "name": "admin_appreciation_settings_postsettings",
        "path": "/post-settings",
        "ref": "admin_pages_sharing_settings_post_settings"
      },
      {
        "name": "admin_appreciation_settings_filesettings",
        "path": "/file-upload",
        "ref": "admin_pages_sharing_settings_file_upload"
      },
      {
        "name": "admin_appreciation_settings_collagesettings",
        "path": "/collage-settings",
        "ref": "admin_pages_sharingsettings_posttemplates"
      },
      {
        "name": "admin_pages_post_settings_postfilters",
        "path": "/post-filters",
        "ref": "admin_ref_post_settings_postfilters"
      },
      {
        "name": "admin_pages_dailyquote",
        "path": "/daily-quotes",
        "ref": null
      }
    ]
  },
  {
    "name": "admin_pages_sharingconfirmations",
    "ref": "admin_pages_sharing_confirmations",
    "icon": "fa-solid fa-comment-check",
    "subMenu": [
      {
        "name": "admin_pages_sharing_rules",
        "path": "/rules",
        "ref": "admin_pages_sharing_confirmations_rules"
      },
      {
        "name": "admin_pages_sharing_deniedposts",
        "path": "/post-waiting-rules",
        "ref": "admin_pages_sharing_confirmations_objectionable_posts"
      },
      {
        "name": "admin_pages_sharing_blackposts",
        "path": "/objectionable-posts",
        "ref": "admin_pages_sharing_confirmations_blacklist_posts"
      },
      {
        "name": "admin_pages_sharing_deniedcomments",
        "path": "/comments-waiting-rules",
        "ref": "admin_pages_sharing_confirmations_objectionable_comments"
      },
      {
        "name": "admin_pages_sharing_blackcomments",
        "path": "/objectionable-comments",
        "ref": "admin_pages_sharing_confirmations_blacklist_comments"
      }
    ]
  },
  {
    "name": "admin_components_sidebar_announcementsettings",
    "ref": "admin_pages_announcement_management",
    "icon": "fa-solid fa-megaphone",
    "subMenu": [
      {
        "name": "admin_announcement_settings_announcementlist",
        "path": "/announcement-settings",
        "ref": "admin_pages_announcement_management_announcement_settings"
      },
      {
        "name": "admin_announcement_settings_announcementcategorylist",
        "path": "/announcement-categories",
        "ref": "admin_pages_announcement_management_announcement_category_list"
      }
    ]
  },
  {
    "name": "admin_pages_performance_management",
    "ref": "admin_pages_performance_management",
    "icon": "fa-solid fa-chart-line",
    "subMenu": [
      {
        "name": "admin_pages_performance_management_companyobjectives",
        "path": "/company-objectives",
        "ref": "admin_pages_performance_management_company_objectives"
      },
      {
        "name": "admin_pages_performance_management_teams",
        "path": "/teams",
        "ref": "admin_pages_performance_management_teams"
      },
      {
        "name": "admin_pages_performance_management_settings",
        "path": "/performance-management-settings",
        "ref": "admin_pages_performance_management_settings"
      },
      {
        "name": "admin_pages_performance_management_reports",
        "path": "/performance-management-reports",
        "ref": "admin_pages_performance_management_reports"
      }
    ]
  },
  {
    "name": "admin_components_sidebar_customrewards",
    "ref": "admin_pages_reward_management",
    "icon": "fa-solid fa-gift",
    "subMenu": [
      {
        "name": "admin_reward_custom_management_orders",
        "path": "/orders",
        "ref": "admin_pages_reward_management_orders"
      },
      {
        "name": "admin_reward_custom_management_rewards",
        "path": "/rewards",
        "ref": "admin_pages_reward_management_rewards"
      },
      {
        "name": "admin_reward_custom_management_rewardcategories",
        "path": "/reward-categories",
        "ref": "admin_pages_reward_management_reward_categories"
      }
    ]
  },
  {
    "name": "admin_components_sidebar_surveysettings",
    "path": "/regular-surveys",
    "ref": "admin_pages_survey_settings_regular_surveys",
    "icon": "fa-solid fa-square-poll-horizontal",
    "subMenu": []
  },
  {
    "name": "admin_pages_answerwin",
    "path": "/answerwin-settings",
    "ref": "admin_pages_answer_win_settings",
    "icon": "fa-solid fa-trophy",
    "subMenu": []
  },
  {
    "name": "admin_challenge_settings",
    "ref": "admin_pages_challenge_settings",
    "icon": "fa-solid fa-flag-checkered",
    "path": "/challenge-settings",
    "subMenu": []
  },
  {
    "name": "admin_pages_word_game",
    "path": "/word-game-settings",
    "ref": "admin_pages_wordgame",
    "icon": "fa-solid fa-game-board",
    "subMenu": []
  },
  {
    "name": "admin_pages_notification",
    "ref": "admin_pages_notification_management",
    "icon": "fa-solid fa-bell",
    "subMenu": [
      {
        "name": "admin_pages_notificationsettings",
        "path": "/notification-management",
        "ref": "admin_pages_notification_management"
      },
      {
        "name": "admin_pages_notificationrecipients",
        "path": "/notification-recipients",
        "ref": "admin_pages_notification_recipients"
      }
    ]
  },
  {
    "name": "admin_pages_community",
    "path": "/community",
    "ref": "admin_pages_community_settings",
    "icon": "fa-solid fa-users",
    "subMenu": []
  },
  {
    "name": "admin_components_hekate_gdpr",
    "path": "/gdpr-settings",
    "ref": "admin_pages_gdpr_settings",
    "icon": "fa-solid fa-file-contract",
    "subMenu": []
  },
  {
    "name": "admin_pages_security_securitysettings",
    "ref": "admin_pages_security_settings",
    "icon": "fa-solid fa-shield",
    "subMenu": [
      {
        "name": "admin_pages_security_multifactorauthentication",
        "path": "/multifactor-authentication",
        "ref": "admin_pages_security_settings_secure_password"
      },
      {
        "name": "admin_pages_security_securepassword",
        "path": "/secure-password",
        "ref": "admin_pages_security_settings_multi_factor_authentication"
      }
    ]
  },
  {
    "name": "admin_components_sidebar_companies",
    "path": "/companies",
    "ref": "admin_system_api_companies_get_list",
    "icon": "fa-solid fa-buildings",
    "subMenu": []
  },
  {
    "name": "admin_components_sidebar_notificationtemplates",
    "path": "/notification-template-settings",
    "ref": "admin_system_apigetnotificationtemplate",
    "icon": "fa-solid fa-envelope",
    "subMenu": []
  },
  {
    "name": "admin_components_sidebar_messagetemplates",
    "path": "/message-templates",
    "ref": "admin_system_api_getmessagetemplate",
    "icon": "fa-solid fa-message",
    "subMenu": []
  },
  {
    "name": "admin_components_sidebar_languagesettings",
    "path": "/language-settings",
    "ref": "admin_system_api_getresourceedit",
    "icon": "fa-solid fa-globe",
    "subMenu": []
  }
]
